import React from "react";
import { withTranslation } from "react-i18next";

class SignupVerify extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { t } = this.props;
        // If you already have the last 4 digits in state/recoil/props, pass them in.
        // Fallback keeps current behavior with "XXXX".
        const lastFour = this.props.lastFour || "XXXX";

        return (
            <div className="container mt-4">
                <div className="spare-dvs1 vh-100 align-items-start">
                    <div className="w-100 float-left">
                        <h1>{t("signupVerify:title")}</h1>

                        <div className="verify-dvs">
                            <div className="verfy-txt">
                                <p>
                                    {t("signupVerify:instructions.top")}{" "}
                                    <strong>{t("signupVerify:lastFourMasked", { lastFour })}</strong>
                                    {t("signupVerify:instructions.bottom")}
                                </p>

                                <a href="#">{t("signupVerify:notYouSignOut")}</a>
                            </div>

                            <div className="verify-inputs">
                                <p>{t("signupVerify:codeLabel")}</p>
                                <input
                                    type="number"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    name=""
                                    id=""
                                    value="verification code"
                                    className="verfct-inpt"
                                />

                                <input
                                    type="submit"
                                    value={t("signupVerify:sendCode")}
                                    name=""
                                    className="send-btn"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// Wrap with namespace "signupVerify"
export default withTranslation(["signupVerify"])(SignupVerify);
